import { RESCHEDULE_CLASS_IMAGE_PATH } from '@lib/constants/reschedule-class'
import { FastlyImage } from '@components/common/image'
import RescheduleModalTitle from '@components/reschedule-course-class/reschedule-modal-title'
import Button from '@components/atoms/button'
import { SUPPORT_WHATSAPP_NUMBER } from '@lib/constants/common'
import { RelationshipManagerType } from '@lib/types/common'
import RMDetails from '@components/reschedule-course-class/rm-details'

type Props = {
  lessonNumber: string | number
  lessonTitle: string
  onGoBack: () => void
  relationshipManager: RelationshipManagerType
  isTeacher: boolean
}

const ContactRm = ({
  lessonNumber,
  lessonTitle,
  onGoBack,
  relationshipManager,
  isTeacher = false,
}: Props) => (
  <div className="flex flex-col space-y-5">
    <div className="self-center">
      <FastlyImage
        src={`${RESCHEDULE_CLASS_IMAGE_PATH}calendar-fail.png`}
        width={100}
        height={100}
      />
    </div>
    <RescheduleModalTitle
      lessonNumber={lessonNumber}
      lessonTitle={lessonTitle}
    />
    {isTeacher ? (
      <p className="self-start leading-tight">
        <span className="font-600">
          Sorry, we couldn&apos;t find any available slot to reschedule this
          class.
        </span>{' '}
        Please connect with student&apos;s Relationship Manager for assistance.
      </p>
    ) : (
      <p className="self-start leading-tight">
        <span className="font-600">
          Sorry, teacher is not available for next 7 days.
        </span>{' '}
        Please connect with your Relationship Manager to reschedule the classes.
      </p>
    )}

    <RMDetails relationshipManager={relationshipManager} />
    <div className="flex space-x-5">
      <Button
        onClick={() =>
          window.open(
            `https://wa.me/${SUPPORT_WHATSAPP_NUMBER.courseClass.value}`,
            '_blank'
          )
        }
        intent="success"
      >
        Message RM on Whatsapp
      </Button>
      <button
        onClick={onGoBack}
        className="focus:outline-none font-600 hover:underline text-orange"
      >
        Go back
      </button>
    </div>
  </div>
)

export default ContactRm
